// extracted by mini-css-extract-plugin
module.exports = {"title":"Bumper_title__cNtcQ","description":"Bumper_description__eTPYr","link":"Bumper_link__Ssl19","cancel":"Bumper_cancel__q4Ov7"};